export default __webpack_public_path__ + "static/media/pathr.ai_logo_stacked_on-blk.ae1c81ad.png";